export default function getResource(label, vars = []) {
    const resources = {
        title: 'Saved for Later',
        moveToBasket: 'Move to Basket',
        moved: 'Moved',
        remove: 'Remove',
        noItems: 'No items saved for later',
        movedToBasket: `has been moved to your ${vars[0]}`,
        gotIt: 'Got It',
        undo: 'Undo',
        deliveryMethodStandard: 'Get It Shipped order',
        deliveryMethodBOPIS: 'Buy Online and Pick Up order',
        deliveryMethodSameday: 'Same-Day Delivery order',
        itemShip: 'This item is not available in your country.'
    };

    return resources[label];
}
